import React, { Component, useState } from "react";
import $ from "jquery";
import { ToastContainer } from "react-toastify";
import toast from "../../helpers/toast";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigFinance";
//var Constant = require("../../constants");
import Constant from "../../constants";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controller_count: 0,
      controller_total: 0,
      module_count: 0,
      module_total: 0,
      clinic_count: 0,
      doctor_count: 0,
      patient_count: 0,
      retailer_count: 0,
      diagnosis_count: 0,
      finance_user_count: 0,
      diagnosis_revenue: 0,
      consultation_revenue: 0,
      om_revenue: 0,
    };
  }

  // 1.To get detais after first render
  componentDidMount = () => {
    this.getControllerCount();
    this.getModuleCount();
    this.getClinicsCount();
    this.getDoctorCount();
    this.getPatientCount();
    this.getRetailerCount();
    this.getDiagnosticsCount();
    this.getFinanceUserCount();
    this.getRevenueCount();
  };

  // 2.To get all Controllers Count
  getControllerCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/getControllerCount"
    )
      .then((response) => {
        var count = response.data.activeData;
        var total = response.data.totalData;
        this.setState({
          controller_count: count,
          controller_total: total,
        });
      })
      .catch((error) => {});
  }

  //3. To get all Controllers Count
  getModuleCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastermodule/getModuleCount"
    )
      .then((response) => {
        var count = response.data.activeData;
        var total = response.data.totalData;
        this.setState({
          module_count: count,
          module_total: total,
        });
      })
      .catch((error) => {});
  }

  // 4.To get all count of Clinics
  getClinicsCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/clinics"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          clinic_count: count,
        });
      })
      .catch((error) => {});
  }

  //5.To get all count of Doctors
  getDoctorCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/doctors"
    )
      .then((response) => {
        var count = response.data.data;
        this.setState({
          doctor_count: count,
        });
      })
      .catch((error) => {});
  }

  // 6. To get all count of Users
  getPatientCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/patients"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          patient_count: count,
        });
      })
      .catch((error) => {});
  }

  // 6. To get all count of Retailers
  getRetailerCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/retailer"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          retailer_count: count,
        });
      })
      .catch((error) => {});
  }

  // Get diagnostics count
  getDiagnosticsCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/diagnosis"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          diagnosis_count: count,
        });
      })
      .catch((error) => {});
  }

  // Get finance user count
  getFinanceUserCount() {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Mastercontrollers/count/finance"
    )
      .then((response) => {
        var count = response.data.data;

        this.setState({
          finance_user_count: count,
        });
      })
      .catch((error) => {});
  }

  getRevenueCount() {
    Httpconfig.httptokenget(Constant.siteurl + "api/FINANCE")
      .then((response) => {
        var count = response.data.data;

        this.setState({
          diagnosis_revenue: count.diagnosis_revenue,
          consultation_revenue: count.consultation_revenue,
          om_revenue: count.om_revenue,
        });
      })
      .catch((error) => {});
  }

  render() {
    const {
      controller_count,
      controller_total,
      module_count,
      module_total,
      pages,
    } = this.state;

    return (
      <section id="main_dashboard">
        <div className="container" id="main_front">
          <div className="row">
            <div className="col-md-12">
              <div className="dash-section">
                <div className="section-header">
                  <h3>Dashboard</h3>
                </div>
              </div>

              <div className="dash_content">
                <div className="row">
                  <div className="col">
                    <div className="doc_info_box admin_blue">
                      <div className="info-box-icon bg-red">
                        <i className="fa fa-hospital-o"></i>
                      </div>
                      <div className="info_box_content ">
                        {/* <Link
                          to="/finance/Viewclinics"
                          className="dash_content_item"
                        > */}
                        <h3 className="info-box-text">No Of Clinics </h3>
                        <p className="info-box-number">
                          {this.state.clinic_count}
                        </p>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="doc_info_box admin_violet">
                      <span className="info-box-icon bg-aqua">
                        <i className="fa fa-user-md"></i>
                      </span>
                      <div className="info_box_content">
                        {/* <Link
                          to="/finance/Viewdoctors"
                          className="dash_content_item"
                        > */}
                        <h3 className="info-box-text">No Of Doctors </h3>
                        <p className="info-box-number">
                          {this.state.doctor_count}
                        </p>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="doc_info_box admin_purple">
                      <span className="info-box-icon bg-blue">
                        <i className="fa fa-user"></i>
                      </span>
                      <div className="info_box_content">
                        {/* <Link
                          to="/finance/Viewpatients"
                          className="dash_content_item"
                        > */}
                        <h3 className="info-box-text">No Of Patients </h3>
                        <p className="info-box-number">
                          {this.state.patient_count}
                        </p>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="doc_info_box admin_lightblue">
                      <span className="info-box-icon bg-green">
                        <i className="fa fa-hospital-o"></i>
                      </span>
                      <div className="info_box_content">
                        {/* <Link
                          to="/finance/ViewRetailers"
                          className="dash_content_item"
                        > */}
                        <h3 className="info-box-text">Pharmacies </h3>
                        <p className="info-box-number">
                          {this.state.retailer_count}
                        </p>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="doc_info_box admin_orange">
                      <span className="info-box-icon bg-orange">
                        <i className="fa fa-hospital-o"></i>
                      </span>
                      <div className="info_box_content">
                        {/* <Link
                          to="/finance/ViewDiagnostics"
                          className="dash_content_item"
                        > */}
                        <h3 className="info-box-text">Diagnostics </h3>
                        <p className="info-box-number">
                          {this.state.diagnosis_count}
                        </p>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="doc_info_box admin_orange">
                      <span className="info-box-icon bg-orange">
                        <i className="fa fa-hospital-o"></i>
                      </span>
                      <div className="info_box_content">
                        {/* <Link
                          to="/finance/ViewFinanceUsers"
                          className="dash_content_item"
                        > */}
                        <h3 className="info-box-text">Finance </h3>
                        <p className="info-box-number">
                          {this.state.finance_user_count}
                        </p>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="doc_info_box admin_orange">
                      <span className="info-box-icon bg-orange">
                        <i className="fa fa-hospital-o"></i>
                      </span>
                      <div className="info_box_content">
                        <Link
                          to="/finance/viewConsultations"
                          className="dash_content_item"
                        >
                          <h3 className="info-box-text">
                            Consultations Revenue
                          </h3>
                          <p className="info-box-number">
                            {this.state.consultation_revenue}
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="doc_info_box admin_orange">
                      <span className="info-box-icon bg-orange">
                        <i className="fa fa-hospital-o"></i>
                      </span>
                      <div className="info_box_content">
                        <Link
                          to="/finance/DiagnosisViewOrders"
                          className="dash_content_item"
                        >
                          <h3 className="info-box-text">
                            Diagnostics Revenue{" "}
                          </h3>
                          <p className="info-box-number">
                            {this.state.diagnosis_revenue}
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="col">
                    <div className="doc_info_box admin_orange">
                      <span className="info-box-icon bg-orange">
                        <i className="fa fa-hospital-o"></i>
                      </span>
                      <div className="info_box_content">
                        <Link
                          to="/finance/Vieworders"
                          className="dash_content_item"
                        >
                          <h3 className="info-box-text">
                            Order Medicine Revenue{" "}
                          </h3>
                          <p className="info-box-number">
                            {this.state.om_revenue}
                          </p>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
